// 後端 error_type 曾出現大小寫、結尾句點不一致（如 'Overtime can only be applied for in advance or retrospectively.'）；
// 比對或查表前先正規化，對照表 key、比對字面值一律存小寫、無結尾句點
export const normalizeErrorType = (errorType?: string | null): string => (
	(errorType || '').trim().toLowerCase().replace(/\.+$/, '')
);
